import * as React from "react";
import type { BlockCategory } from "src/types";

export default function useSelectionMenu() {
  const [currentCategory, setCurrentCategory] = React.useState<BlockCategory>(
    null
  );
  const [isOpen, setOpen] = React.useState(false);
  const [isDefaultSelection, setDefaultSelection] = React.useState(false);

  const closeSelectionMenu = React.useCallback(() => setOpen(false), []);

  const openSelectionMenu = React.useCallback(
    (category: BlockCategory, withSelection?: boolean) => {
      setOpen(true);
      setCurrentCategory(category);
      setDefaultSelection(withSelection);
    },
    []
  );

  const clearSelection = React.useCallback(() => setCurrentCategory(null), []);

  const closeMenuAndClearSelection = React.useCallback(() => {
    closeSelectionMenu();
    clearSelection();
  }, [closeSelectionMenu, clearSelection]);

  return {
    isOpen,
    currentCategory,
    isDefaultSelection,
    setDefaultSelection,
    closeSelectionMenu,
    openSelectionMenu,
    clearSelection,
    closeMenuAndClearSelection,
  };
}
